import React from "react";
import CurrencyFormat from "react-currency-format";
import {
  DropdownWrapper,
  DropdownContent,
} from "components/organisms/Dropdown/Dropdown.styles";
import { InputField } from "components/molecules/InputField/InputField";
export default function Dropdown({
  challenge,
  inputs,
  handleInputChange,
  inputValues,
  active,
  validationError,
  lang,
  placeholder,
}) {
  const handleClick = (e) => {
    let question = e.target.nextSibling;
    let current = e.target;
    current.classList.toggle("active");
    question.classList.toggle("active");
  };
  const handleTipClick = (e) => {
    const parent = e.target.closest("label");
    parent.nextSibling.classList.toggle("active");
  };
  return (
    <DropdownWrapper>
      <h3 className={active ? "active" : null} onClick={handleClick}>
        {challenge.name}
      </h3>
      <DropdownContent className={active ? "active" : null}>
        {inputs &&
          inputs.map((field) => (
            <InputField column="true" key={field.id}>
              <label>
                {field.label}
                <span onClick={handleTipClick}>?</span>
              </label>

              <p className="tip">{field.tip}</p>

              <CurrencyFormat
                isNumericString={true}
                decimalSeparator=","
                value={inputValues[field.id] || ""} // Set a default value (0 in this case)
                thousandSeparator=" "
                suffix={" " + field.unit}
                placeholder={lang === "pl" ? placeholder.pl : placeholder.en}
                onValueChange={(values) => {
                  const { value } = values;
                  handleInputChange(field.id, value, inputs, challenge);
                }}
              />
              {validationError[field.id] && (
                <p className="error">{validationError[field.id]}</p>
              )}
            </InputField>
          ))}
      </DropdownContent>
    </DropdownWrapper>
  );
}
